/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { CONNECT_WORKSPACE_TYPE_FULL, CONNECT_WORKSPACE_TYPE_LIMITED } from './ConnectWorkspace.entity.constant';

/**
 * The Connect Workspace, and its properties.
 */
export type EntityConnectWorkspace = io.TypeOf<typeof ConnectWorkspace>;

/**
 * The Connect Workspace, and its properties.
 * @export
 */
export const ConnectWorkspace = io.type(
  {
    workspaceId: io.string,
    workspaceName: io.string,
    workspaceType: io.union([io.literal(CONNECT_WORKSPACE_TYPE_FULL), io.literal(CONNECT_WORKSPACE_TYPE_LIMITED)]),
  },
  `ConnectWorkspace`,
);
